<template>
    <component :is="layout" v-if="!loadingApp">
        <router-view />
    </component>
    <app-block-loader v-else>
        <template #default>
            <app-svg name="b-loader" />
        </template>
    </app-block-loader>
</template>

<script>
import { defineAsyncComponent, ref, onMounted } from 'vue';
import { app } from '@beautybox/ui-kit/plugins/app';
import usePricesStore from '@/stores/filters/prices';
const LinkLayout = defineAsyncComponent(() => import('@/layouts/link-layout'));
const LkLayout = defineAsyncComponent(() => import('@/layouts/lk-layout'));

export default {
    components: { LinkLayout, LkLayout },
    mixins: [app],
    setup() {
        const pricesStore = usePricesStore();
        const { getPriceTypes } = pricesStore;

        const loadingApp = ref(true);

        const loadGlobalData = async () => {
            loadingApp.value = true;
            await Promise.all([getPriceTypes()]);
            loadingApp.value = false;
        };

        onMounted(() => {
            loadGlobalData();
        });

        return { getPriceTypes, loadingApp, loadGlobalData };
    },
};
</script>
